import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    // wrapper: {},
    container: {
      '&&': {
        '& article': {
          // maxHeight: '69vh',
          // overflow: 'auto',
          [theme.breakpoints.up('md')]: {
            paddingRight: theme.spacing(9),
          },

          '& h2': {
            margin: theme.spacing(1.5, 0),
            color: theme.palette.primary.main,
            fontSize: theme.typography.pxToRem(24),
            fontWeight: theme.typography.fontWeightBold,
          },
        },
      },
    },

    imageWrapper: {
      minHeight: '45vw',

      [theme.breakpoints.up('sm')]: {
        minHeight: 'unset',
      },
    },
    imageContainer: {
      marginBottom: theme.spacing(1.5),
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,

      [theme.breakpoints.up('sm')]: {
        position: 'relative',
        top: 'unset',
        left: 'unset',
        right: 'unset',
      },

      '& > div#training-data-container': {
        position: 'absolute',
        left: 20,
        bottom: 20,

        '& > p#training-date': {
          marginBottom: theme.spacing(1),
          fontSize: theme.typography.pxToRem(11),
          color: theme.palette.primary.contrastText,
          textShadow: '1px 1px 2px #0000006b',
        },
        '& > p#training-category': {
          color: '#fce700',
          fontSize: theme.typography.pxToRem(14),
          fontWeight: theme.typography.fontWeightBold,
          textShadow: '1px 1px 2px #0000006b',
        },
      },
      '& > img': {
        width: '100%',
        maxWidth: '100%',
        maxHeight: 265,
        objectFit: 'cover',
        borderRadius: 13,
      },
    },

    contentContainer: {
      '& p': {
        marginBottom: theme.spacing(2),
      },
      '& p#training-description': {
        fontWeight: theme.typography.fontWeightBold,
      },
    },

    aside: {
      margin: '0 auto',
      '& > section': {
        marginTop: theme.spacing(6),
        position: 'sticky',
        top: '30%',

        '& h3': {
          marginBottom: theme.spacing(1),
          fontSize: theme.typography.pxToRem(20),
          fontWeight: theme.typography.fontWeightBold,
        },

        '& section#aside-categories-container': {
          minHeight: 90,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',

          '& a': {
            fontSize: theme.typography.pxToRem(16),
            fontWeight: theme.typography.fontWeightBold,
          },
        },
      },
    },
    suggestionsWrapper: {
      marginTop: theme.spacing(3),

      '& > div': {
        marginTop: theme.spacing(2),
        minHeight: 355,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      },
    },
    trainingCard: {
      minHeight: 165,
    },
  })
);

export default useStyles;
